import React from 'react';
import { Link } from 'react-router-dom';

const FooterBlue = () => {
    return (
        <footer className="bg-black  py-12 px-4" style={{ color: "#a2adb8" }} >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div>
                        <h3 className="text-xl font-bold gray-800 mb-4 pb-2 border-b-2 border-gray-800 inline-block">FLEETY</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/about-us" className="text-gray-400 hover:text-blue-600 transition">
                                    About Us
                                </Link></li>
                            <li>
                                <Link to="/contact-us" className="text-gray-400 hover:text-blue-600 transition">Contact Us</Link>
                            </li>
                            <li><Link to="/truckers-forum" className="text-gray-400 hover:text-blue-600 transition">Trucker Forum</Link></li>
                            <li><Link to="/book-demo" className="text-gray-400 hover:text-blue-600 transition">Book Demo</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold gray-800 mb-4 pb-2 border-b-2 border-gray-800 inline-block">CARRIERS</h3>
                        <ul className="space-y-2">
                            <li><Link to="/carrier-registration" className="text-gray-400 hover:text-blue-600 transition">Carrier Registration</Link></li>
                            <li><Link to="/carrier-login" className="text-gray-400 hover:text-blue-600 transition">Carrier Login</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold gray-800 mb-4 pb-2 border-b-2 border-gray-800 inline-block">Get in Touch</h3>
                        <ul className="space-y-2">
                            <li className="text-gray-400">support@fleetycdl.com</li>
                            <li className="text-gray-400">Mon - Fri: 9:00 - 18:00</li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold gray-800 mb-4 pb-2 border-b-2 border-gray-800 inline-block">FLEETY'S NEWSLETTER</h3>
                        <div className="space-y-3">
                            <input
                                type="email"
                                placeholder="Email"
                                className="w-full p-3 border-2 border-gray-800 rounded bg-transparent gray-800"
                            />
                            <button className="w-full   text-white font-bold py-3 rounded   transition" style={{ background: "#1e90ff" }} >
                                Sign Up
                            </button>
                        </div>
                        <p className=" text-base mt-4 font-thin" style={{ color: "#a2adb8" }}>
                            I agree to receive emails from Fleety.com. I understand that I can unsubscribe at any time. By clicking on "Sign Up", you agree to our Terms of Use and Privacy Policy.
                        </p>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-10 pt-6 text-gray-400 text-sm flex flex-col md:flex-row justify-between items-center">
                    <p>Copyright © 2025 Fleety. All rights reserved
                        <a href="#" className="  hover:underline" style={{ color: "#a2adb8" }} > Site Map</a></p>
                    <p className="mt-2 md:mt-0">
                        <a href="/terms-of-use" className="  hover:underline mx-2" style={{ color: "#a2adb8" }}>Terms of Use</a> |
                        <a href="/privacy-policy" className=" hover:underline mx-2" style={{ color: "#a2adb8" }}>Privacy Policy</a> and
                        <a href="/cookie-policy" className=" hover:underline mx-2" style={{ color: "#a2adb8" }}>Cookie Policy</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default FooterBlue;
